var staggerHandler = {
	$staggerElements = [],

	setMargins: function($element, margin, direction) {
		margin = parseFloat(margin);
		if (direction == 'down') {
			var originalPadding = $element.data('original-padding');
			if (!originalPadding) {
				originalPadding = $element.css('padding-top');
				$element.data('original-padding', originalPadding);
			}
			originalPadding = parseFloat(originalPadding.replace('px',''));
			$element.css('padding-top', (margin+originalPadding)+'px');
		} else {
			var prevPadding = $element.prev().data('original-padding');
			if (!prevPadding) {
				prevPadding = $element.prev().find("> *:last-child").css('padding-bottom');
				$element.prev().data('original-padding',prevPadding);
			}
			prevPadding = parseFloat(prevPadding.replace('px',''));
			margin = margin + prevPadding;
			$element.prev().find("> *:last-child").css('padding-bottom', margin+'px');
		}
		$element.css('margin-top', '-'+margin+'px');
	},

	resetStagger: function() {
		var self = this;
		this.$staggerElements.each(function() {
			var $target = $(this);
			var staggerParams = $target.data('stagger').split('-');
			var staggerDirection = $target.data('stagger-direction');
			var staggerSmall, staggerMedium, staggerLarge;
			if (staggerParams[0].indexOf('%') !== -1) {
				var referenceHeight = 0;
				var heightTarget = $target.data('stagger-height-target');
				if (heightTarget) {
					var idx = heightTarget.indexOf(' ');
					var temp = [heightTarget.slice(0,idx), heightTarget.slice(idx+1)];
					if (temp[0] == 'self') {
						referenceHeight = $target.find(temp[1]).outerHeight();
					} else {
						referenceHeight = $(temp[1]).outerHeight();
					}
				} else {
					referenceHeight = $target.prev().height(); //intentionally no using outerHeight
				}
				staggerParams[0] = staggerParams[0].replace('%', '');
				staggerSmall = referenceHeight * (staggerParams[0] / 100.0);
				staggerLarge = referenceHeight * (staggerParams[0] / 100.0);
				staggerMedium = referenceHeight * (staggerParams[0] / 100.0);
			} else {
				staggerSmall = parseInt(staggerParams[0]);
				staggerLarge = parseInt(staggerParams[1]);
				staggerMedium = staggerSmall + 0.5 * (staggerLarge - staggerSmall);	
			}
			if (Foundation.MediaQuery.only('small')) {
				self.setMargins($(this), staggerSmall, staggerDirection);
			} else if (Foundation.MediaQuery.only('medium')) {
				self.setMargins($(this), staggerMedium, staggerDirection);
			} else {
				self.setMargins($(this), staggerLarge, staggerDirection);
			}
		});
	},

	init: function() {
		var self = this;
		this.$staggerElements = $('[data-stagger]');
		$window.on("resize", function() {
			self.resetStagger();
		})
	}
}